<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('projects.label.addProjectComment')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                    <span class="svg-icon svg-icon-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                              fill="currentColor" />
                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                              fill="currentColor" />
                      </svg>
                    </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <div class="row mb-5">
              <div class="col-11">
                <Input
                    container-class="form-group"
                    :name="`comment-name`+id"
                    type="text"
                    :placeholder="$t('projects.label.addTaskComment')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    size="lg"
                    :isRequired="true"
                    v-model="formData.comment"
                    :isInputGroup="true"
                >
                  <template #rightAddon>
                    <button type="submit" class="position-absolute border-0 btn btn-icon btn-primary top-50 translate-middle" style="right: -60px">
                      <i class="fa fa-paper-plane text-white"></i>
                    </button>
                  </template>
                </Input>
              </div>
            </div>

            <div class="row mh-200px scroll-y">
              <div v-for="comment in formData.oldComments" :key="comment.id" class="col-12 mb-2">
                <div class="card shadow-sm p-2" >
                  <div class="d-flex justify-content-between mb-">
                    <span class="fs-6 fw-bolder">{{ comment.user_name }}</span>
                    <p>
                      {{ formatRemainingTime(comment.created_at) }}
                    </p>
                  </div>
                  <div class="p-4 fs-5" style="border-radius: 5px; width: 100%; background-color: #f5f8fa;" v-html="comment.comment"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {computed, defineEmits, defineProps, onMounted, ref, watch} from 'vue'
import RequiredText from "@/components/RequiredText.vue";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import {createComment} from "@/Modules/Projects/store/modules/projects/actions";
import { formatRemainingTime } from '@/mixins/Helpers';

const store = useStore();

const emits = defineEmits(["load"]);
const props = defineProps({
  id: {type: String, required: true},
  classes: String,
  parent: String,
  form: {
    type: Object,
    default: () => ({
      id: "",
      comment: "",
      oldComments: []
    }),
  }
})

const isLoading = ref(false);
const formData = ref(props.form);

watch(() => props.form, () => {
  formData.value = props.form
}, {deep: true})

function closeModal() {
  if(props.parent) {
    $("#" + props.parent).modal("toggle");
  }
  $("#" + props.id).modal("toggle");
}

function submitForm() {
  isLoading.value = true

  store.dispatch('projects/createComment', {comment: formData.value.comment, id: formData.value.id})
      .then(res => {
        closeModal()
        emits('callback')
        formData.value.comment = "";
        window.toastr['success'](i18n.global.t('notification.comments_created'))
      })
      .catch()
      .finally(() => isLoading.value = false)
}

onMounted(() => {
  store.dispatch('projects/loadProjectReactionEnum')
})

</script>



<style scoped>

</style>